import React from 'react';
import { VStack } from 'native-base';
import { graphql } from '../../__generated__';
import { useQuery } from '@apollo/client';
import { OrdersTable } from '../components/Table/OrdersTable';
import { Fulfillment } from '../../__generated__/graphql';


export const pendingBookingQuery = graphql(`
query pendingBookingFulfilments {
    fulfilmentsPendingBooking {
      id
      createdAt
      total
      dispensed
      completed
      booked
      items {
        QTY
        ID
        PrescriptionID
      }
      street
      shipping
      subtotal
      suburb
      state
      postcode
      total
      suburb
      prescriptionIDs
      creatingRole
      creatingRole
      deliveryMethod
      customer {
        id
        given
        dob
        brand
        mobile
        name
      }
      __typename
    }
  }
`);

export default function () {
  const { data, loading } = useQuery(pendingBookingQuery, {
    fetchPolicy: 'cache-and-network',
  });


  return (
    <VStack flex={1}>
      <OrdersTable orders={data?.fulfilmentsPendingBooking as Fulfillment[]} loading={loading} />

    </VStack>
  );
}
